module.exports = { raw: '9.1.2' };



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 9
// module chunks = 0 1